import React, { useEffect, useMemo } from 'react';
import ReportSectionLoading from 'features/frontoffice/component/reportSectionLoading';
import Carousel from 'common/bstCarousel';
import { AppConfig } from 'AppConfig';
import { store } from 'store/store';
import { useSelector } from 'react-redux';
import * as UserTypes from 'features/user/userTypes';
import * as Actions from 'features/frontoffice/actions/actions';
import useWindowDimensions from 'common/hooks/useWindowDimensions';
import NoAvailableReports from 'features/frontoffice/component/noAvailableReports';
import { sortReports } from 'utils/reportSort';

const ExplorerReport = ({ isTablet = false, searchTerm = '', sortBy, viewMode = 'grid' }) => {
  const { width } = useWindowDimensions();
  const explorers = useSelector((state) => state.fo.explorers);
  const explorersLoading = useSelector((state) => state.fo.explorersLoading);
  const currentTenantCd = useSelector((state) => state.user.currentTenantCd);
  const sortKey = typeof sortBy === 'string' ? sortBy : sortBy?.value;

  useEffect(() => {
    store.dispatch({
      type: UserTypes.APP_SWITCHED,
      payload: AppConfig.HEADER_MENU_TYPE.FO
    });
    store.dispatch(Actions.getExplorerReport());
  }, [currentTenantCd]);

  const filteredExplorers = useMemo(() => {
    const list = Array.isArray(explorers) ? explorers : [];
    const term = (searchTerm || '').trim().toLowerCase();
    const baseList = sortKey === 'recently_saved' ? list.filter((e) => e.favorited === true) : list;
    if (!term) return baseList;
    return baseList.filter((item) => {
      const title = (item?.displayText || '').toLowerCase();
      const desc = (item?.description || '').toLowerCase();
      return title.includes(term) || desc.includes(term);
    });
  }, [explorers, searchTerm, sortKey]);
  
  const sortedExplorers = useMemo(() => sortReports(filteredExplorers, sortKey), [filteredExplorers, sortKey]);

  return (
    <>
    {explorersLoading ? (
      <ReportSectionLoading count={10} variant="grid" />
    ) :
      !sortedExplorers?.length ? (
        <NoAvailableReports />
      ) : (
      <Carousel
        items={sortedExplorers}
        type={AppConfig.EXPLORE_CAROUSEL}
        viewWidth={width}
        cardWidth={AppConfig.HOME_RECOMMEND_CARD_WIDTH}
        cardHeight={AppConfig.HOME_RECOMMEND_CARD_HEIGHT}
        isTablet={isTablet}
        viewMode={viewMode}
      />
    )}
    </>
  );
};

export default ExplorerReport;
